module.exports = __webpack_public_path__ + "step3_child_to_parent_son.df47f763.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step3_child_to_parent_son.jpg
// module id = Fsbj
// module chunks = 0